export const colors = {
  Pending: '#B78103',
  Approved: '#229A16',
  Completed: '#229A16',
  'Admin approved': '#229A16',
  'Manager approved': '#229A16',
  'HR approved': '#229A16',
  'Scheduling required': '#B78103',
  'Scheduling completed': '#229A16',
  Past: '#229A16',
  Rejected: '#B72136',
  Pass: '#229A16',
  Fail: 'rgb(255, 72, 66)',
};

export const boxBackground = {
  All: 'rgba(15, 7, 17, 0.12)',
  Pending: 'rgba(255, 193, 7, 0.12)',
  Approved: 'rgba(84, 214, 44, 0.12)',
  Completed: 'rgba(84, 214, 44, 0.12)',
  'Admin approved': 'rgba(84, 214, 44, 0.12)',
  'Manager approved': 'rgba(84, 214, 44, 0.12)',
  'HR approved': 'rgba(84, 214, 44, 0.12)',
  Past: 'rgba(84, 214, 44, 0.12)',
  'Scheduling required': 'rgba(255, 193, 7, 0.12)',
  'Scheduling completed': 'rgba(84, 214, 44, 0.12)',
  Rejected: 'rgba(255, 72, 66, 0.16)',
  Pass: 'rgba(84, 214, 44,0.12)',
  Fail: 'rgba(255, 72, 66, 0.16)',
};
